import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import AddIcon from "../../components/Icons/AddIcon";
import Button from "../../components/Shared/Button";
import Spinner from "../../components/Shared/Spinner";
import { getBlogs } from "../../api/Blogs/GetAllBlogs";
import BlogCard from "../../components/Shared/BlogCard";
import AddBlog from "../../components/Blogs/AddBlog";
import TrashIcon from "../../components/Icons/TrashIcon";
import DeleteModal from "../../components/Shared/DeleteModal";
import { DeleteBlog } from "../../api/Blogs/DeleteBlog";
import { Edit } from "lucide-react";
import { Link } from "react-router-dom";
import DashboardInlineBackButton from "../../components/Dashboard/Shared/DashboardInlineBackButton";
const Blogs = () => {
  const [showAddCourse, setShowAddCourse] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [deleteId, setDeleteId] = useState<string | null>(null);

  const { data: BlogsResponse, isLoading: isBlogsLoading } = useQuery({
    queryFn: getBlogs,
    queryKey: ["blogs"],
    staleTime: 0,
    refetchInterval: 0,
  });

  const blogs = BlogsResponse?.data?.blogsData || [];

  const handleAddCourseSuccess = () => {
    setShowAddCourse(false);
  };

  const handleDelete = async (id: string) => {
    await DeleteBlog(id);
    toast.success("Blog deleted successfully");
  };

  if (isBlogsLoading)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner />
      </div>
    );

  return (
    <div>
      {showAddCourse ? (
        <div className="space-y-4">
          <DashboardInlineBackButton
            label="Back to blogs"
            onClick={() => setShowAddCourse(false)}
          />
          <AddBlog onSuccess={handleAddCourseSuccess} />
        </div>
      ) : (
        <div>
          <div className="flex justify-between items-center py-7">
            <h1 className="text-burntBlack font-bold text-[32px]">All Blogs</h1>
            <Button
              onClick={() => setShowAddCourse(true)}
              className="!h-12 w-40 !text-sm font-bold rounded-md !bg-[#4379EE] hover:!bg-primary"
              variant="primary"
            >
              <AddIcon className="mr-1.5" />
              Add New Blog
            </Button>
          </div>
          <div className="grid grid-cols-3 place-content-between gap-4">
            {blogs.map((blog, index) => (
              <div key={index} className="relative">
                <BlogCard
                  id={blog.id}
                  title={blog.title}
                  img={blog.img_url}
                  description={blog.description}
                />
                <div className="absolute bottom-5 right-4">
                  <div className="flex gap-2">
                    <Link to={`/dashboard/blogs/edit-blog/${blog.id}`}>
                    <Edit size={20}/>
                    </Link>
                    <button
                    onClick={() => {
                      setIsOpen(true);
                      setDeleteId(blog.id || null);
                    }}
                    className="text-[#EF3826]"
                  >
                    <TrashIcon />
                  </button>

                  </div>
                  <DeleteModal
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                    mutationFn={handleDelete}
                    itemId={deleteId || ""}
                    queryKey="blogs"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Blogs;
